export default __webpack_public_path__ + "static/media/J240_J730_J750_21AXXXA_GENERIC_SILVER.bbef45de.STEP";